import { FC } from 'react';
import { ErrorRounded } from '@mui/icons-material';
import { InputAdornment, Stack, TextField } from '@mui/material';
import { useFormikContext } from 'formik';

import { LoadingButton } from '~components/atoms/custom/Button';
import { LocalizationTypography } from '~components/organisms/localization';
import { useLanguageContext } from '~providers';

export type DirectLoginValues = { username: string; password: string };

export const DirectLoginForm: FC = () => {
  const { lt } = useLanguageContext();

  const formik = useFormikContext<DirectLoginValues>();

  const hasUsernameError =
    formik.touched.username && Boolean(formik.errors.username);
  const hasPasswordError =
    formik.touched.password && Boolean(formik.errors.password);

  return (
    <Stack component="form" spacing={2} onSubmit={formik.handleSubmit}>
      <TextField
        fullWidth
        name="username"
        label={lt(
          'app.rentalPage.newStepThree.campusCard.username',
          'Username',
        )}
        value={formik.values.username}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={hasUsernameError}
        helperText={formik.touched.username && formik.errors.username}
        autoComplete="username"
        InputProps={{
          endAdornment: hasUsernameError ? (
            <InputAdornment position="end">
              <ErrorRounded color="error" />
            </InputAdornment>
          ) : null,
        }}
        FormHelperTextProps={{ sx: { marginLeft: 0 } }}
      />
      <TextField
        fullWidth
        type="password"
        name="password"
        label={lt(
          'app.rentalPage.newStepThree.campusCard.password',
          'Password',
        )}
        value={formik.values.password}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={hasPasswordError}
        helperText={formik.touched.password && formik.errors.password}
        autoComplete="current-password"
        InputProps={{
          endAdornment: hasPasswordError ? (
            <InputAdornment position="end">
              <ErrorRounded color="error" />
            </InputAdornment>
          ) : null,
        }}
        FormHelperTextProps={{ sx: { marginLeft: 0 } }}
      />
      <LoadingButton
        type="submit"
        isLoading={formik.isSubmitting}
        disabled={!formik.dirty || !formik.isValid}
      >
        <LocalizationTypography
          textId="app.rentalPage.newStepThree.campusCard.continue"
          defaultText="Continue"
          variant="Poppins/Subheading-sm"
        />
      </LoadingButton>
    </Stack>
  );
};
